import {
  Body,
  Button,
  Flex,
  Grid,
  Heading,
  Image,
  Label,
  Stack,
  VStack,
} from '@hover/blueprint';
import { hBack } from '@hover/icons';
import React from 'react';
import { useHistory } from 'react-router';

import { useIsMobileSize } from 'src/modules/renderings/hooks';
import {
  TranslationNamespace,
  useEffectOnMount,
  useTranslate,
} from 'src/shared/hooks';
import { External } from 'src/shared/route';
import { buttonPressed, pageViewed } from 'src/shared/telemetry';

const Footer = () => {
  const history = useHistory();
  const goBack = () => history.goBack();
  const t = useTranslate(TranslationNamespace.SHARED);
  const isMobile = useIsMobileSize();

  const navigateToNext = () => {
    window.location.href = External.START.path;
  };

  return (
    <VStack display="flex" mt={300} width={1}>
      <Flex
        flexDir={{ base: 'column', tablet: 'row' }}
        justifyContent="space-between"
        width={1}
      >
        {isMobile ? (
          <Button
            as="a"
            href="https://hover.app.link/6Ze7Db8w7Cb"
            mb={200}
            textDecor="none"
          >
            {t('onboarding.downloadApp')}
          </Button>
        ) : (
          <Button
            fill="minimal"
            iconBefore={hBack}
            onClick={() => {
              buttonPressed({
                feature: 'onboarding',
                page_or_screen_name: 'Onboarding_download',
                button_text: 'Back',
              });
              goBack();
            }}
          >
            {t('onboarding.back')}
          </Button>
        )}
        <Button
          onClick={() => {
            buttonPressed({
              feature: 'onboarding',
              page_or_screen_name: 'Onboarding_download',
              button_text: 'Finish',
            });
            navigateToNext();
          }}
          variant={{ base: 'tertiary', tablet: 'primary' }}
          width={{ base: 1, tablet: 'auto' }}
        >
          {t('onboarding.finish')}
        </Button>
      </Flex>
    </VStack>
  );
};

export const DownloadApp = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const isMobile = useIsMobileSize();

  useEffectOnMount(() => {
    pageViewed({
      page_or_screen_name: 'Onboarding_download',
      feature: 'onboarding',
    });
  });

  return (
    <Grid alignContent="space-between" alignItems="stretch" flex={1} width={1}>
      <Stack
        direction={{ base: 'column', tablet: 'row' }}
        flex={1}
        flexWrap="wrap"
        justifyContent={{ base: 'start', tablet: 'space-around' }}
        marginTop={300}
        spacing={0}
        width={1}
      >
        <Flex flexDir="column" maxW={750}>
          <Heading size={{ base: 700, tablet: 800 }}>
            {t('onboarding.downloadTheHoverApp')}
          </Heading>
          <Body color="neutral.600">
            {t('onboarding.takePropertyPhotosOnTheGo')}
          </Body>
        </Flex>
        {!isMobile && (
          <Flex
            alignItems="start"
            flex={{ base: 1, tablet: 0.4 }}
            flexDir="column"
          >
            <Label mb={200}>{t('onboarding.scanQRCode')}</Label>
            <Image
              alt="qr code"
              src="https://assets.hover.to/website-images/onboarding-qr-code.jpg"
              width={700}
            />
          </Flex>
        )}
      </Stack>
      <Footer />
    </Grid>
  );
};
